import React, { useRef } from 'react';
import { Box, Typography, Button, Divider } from '@mui/material';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import { ReactComponent as DownloadIcon } from '../../../public/assets/downloadIcon.svg';
import { ReactComponent as ShareIcon } from '../../../public/assets/shareIcon.svg';
import QRCodeGenerator from './QRCodeGenerator';

export default function PratapScanAndPayCard({ qrString, merchantVpa, merchantName }) {
  const cardRef = useRef(null);

  const generatePDF = async () => {
    if (!cardRef.current) return null;

    const canvas = await html2canvas(cardRef.current, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new JsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: [canvas.width, canvas.height]
    });

    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    return pdf;
  };

  const handleDownloadPDF = async () => {
    const pdf = await generatePDF();
    if (pdf) pdf.save(`${merchantVpa}.pdf`);
  };

  const handleSharePDF = async () => {
    const pdf = await generatePDF();
    if (!pdf) return;

    const pdfBlob = pdf.output('blob');
    const file = new File([pdfBlob], `${merchantVpa}.pdf`, {
      type: 'application/pdf'
    });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({
          title: 'Scan & Pay Card',
          text: 'Here is my Scan & Pay QR card.',
          files: [file]
        });
      } catch (err) {
        console.error('Share failed:', err);
      }
    } else {
      pdf.save(`${merchantVpa}.pdf`);
      alert('Sharing is not supported on this device/browser. PDF downloaded instead.');
    }
  };

  return (
    <Box sx={{ textAlign: 'center', width: '70%', mx: 'auto' }}>
      {/* White Content Area */}
      <Box
        ref={cardRef}
        sx={{
          backgroundColor: '#ffffff',
          borderRadius: 2
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
          <img
            src="/assets/Pratap/Pratap_logo.png"
            alt="Pratap Logo"
            style={{ height: 150, width: '100%' }}
          />
        </Box>

        {/* Scan & Pay */}
        <Typography
          sx={{
            mb: 1,
            color: '#000',
            fontWeight: 700,
            fontSize: 24,
            fontFamily: 'Montserrat'
          }}
        >
          Scan & Pay
        </Typography>

        <Box
          sx={{
            border: '1px solid grey',
            borderRadius: '20px',
            py: 2,
            mx: 5
          }}
        >
          <QRCodeGenerator qrString={qrString} />
        </Box>

        {/* Merchant Name */}
        <Typography
          sx={{
            mt: 1,
            color: 'primary.main',
            fontWeight: 600,
            fontFamily: 'Montserrat',
            fontSize: 14
          }}
        >
          {merchantName}
        </Typography>
        <Divider
          sx={{
            mx: 2,
            mt: 1,
            backgroundColor: 'grey',
            height: '2px',
            width: '90%'
          }}
        />

        {/* UPI ID */}
        <Typography
          sx={{
            mt: 1,
            color: 'primary.main',
            fontWeight: 600,
            fontFamily: 'Montserrat',
            fontSize: 14
          }}
        >
          {merchantVpa}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <img
            src="/assets/Pratap/Pratap_bottom.png"
            alt="Pratap Logo"
            style={{ height: '100%', width: '100%' }}
          />
        </Box>
      </Box>

      {/* Buttons */}
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button
          variant="contained"
          onClick={handleDownloadPDF}
          endIcon={<DownloadIcon />}
          sx={{ p: 1, width: '50%' }}
        >
          Download
        </Button>
        <Button
          variant="outlined"
          onClick={handleSharePDF}
          endIcon={<ShareIcon />}
          sx={{ p: 1, width: '50%' }}
        >
          Share
        </Button>
      </Box>
    </Box>
  );
}
